import * as Constants from 'constants/index';

interface ToolsBarState {
  selectedTool: string;
}

// Action carries the selected tool `name`; typed minimally at the reducer boundary.
interface ToolsBarAction {
  type: string;
  name?: string;
}

const initialState: ToolsBarState = {
  selectedTool: Constants.SuperAdmin.TOOL_BUTTON_NAMES.INSTITUTION_LICENSE,
};

export function ToolsBarReducer(
  state: ToolsBarState = initialState,
  action: ToolsBarAction,
): ToolsBarState {
  switch (action.type) {
    case Constants.SuperAdmin.SELECTOR_ACTION_TYPES.SELECT_TOOL:
      return {
        selectedTool: action.name as string,
      };
    default:
      return state;
  }
}
